import { useContainer } from '@hub-la/fe-container'
import { HttpClient } from '@hub-la/fe-core-http-client'
import { useQuery } from '@tanstack/react-query'
import { GetInvoicesInput } from '../../domain/dtos/get-invoices-input'
import { QueryKey } from '../../domain/enums/query-keys'
import { GetInvoices } from '../../usecases/get-invoices'

export const useGetInvoices = (input: GetInvoicesInput, isLoading: boolean) => {
  const container = useContainer()

  const offerIds = input.offers.filter(({ id }) => id !== 'all').map(({ id }) => id)
  const enabled = !isLoading && offerIds.length > 0
  const initialData = {
    page: 1,
    pageSize: 0,
    total: 0,
    lastPage: 1,
    items: [],
  }

  return useQuery(
    [QueryKey.getInvoices, JSON.stringify(input)],
    ({ signal }) => {
      if (!enabled) {
        return Promise.resolve(initialData)
      }
      return new GetInvoices(container.get(HttpClient)).execute(input, signal)
    },
    {
      retry: 3,
      retryOnMount: false,
      refetchOnWindowFocus: false,
      initialData,
      enabled,
    },
  )
}
